import React from 'react';
import PropTypes from 'prop-types';

import PanasonicLogo from 'assets/images/panasonic-logo.png';

import {PlatformFooter} from 'pac-platform-ui-components';

import {Tile} from 'pac-ux-components';


import {NavLink, Outlet, useSearchParams} from 'react-router-dom';

import {Box, Center, createStyles, Image, Stack} from '@mantine/core';

import {PageFooter} from 'features/home/components/PageFooter';

import {Auth} from '@aws-amplify/auth';


const useStyles = createStyles((theme) => {
    // console.debug('theme', theme);
    // console.debug('window dimetions', window.innerWidth);

    return {
        wrapper: {
            [`@media (max-width: ${theme.breakpoints.xs}px)`]: {
                width: '100%',
            },

            [`@media (min-width: ${theme.breakpoints.sm}px)`]: {
                width: '70%',
            },

            [`@media (min-width: ${theme.breakpoints.md}px)`]: {
                width: '60%',
            },

            [`@media (min-width: ${theme.breakpoints.lg}px)`]: {
                width: '45%',
            },

            [`@media (min-width: ${theme.breakpoints.xl}px)`]: {
                width: '40%',
            },
        },
    };
});

const DefaultLayout = ({children}) => {
    const {classes} = useStyles();

    const [searchParams] = useSearchParams();
    if (searchParams.get('global-sign-out')) {
        Auth.signOut({global: true});
    }


    return (
        <Center>
            <Stack p="xl" spacing="xl" className={classes.wrapper}>
                <Tile elevation="medium">
                    <Stack p="xl" spacing="xl">
                        <Center className="border-bottom-primary">
                            <NavLink to="/">
                                <Box mb="sm">
                                    <Image
                                        src={PanasonicLogo}
                                        alt="Panasonic Avionics"
                                    />
                                </Box>
                            </NavLink>
                        </Center>

                        <Box p="s">
                            <Outlet/>
                            {children}
                        </Box>

                        <PageFooter/>
                    </Stack>
                </Tile>

                <Box mt="xl">
                    <PlatformFooter/>
                </Box>
            </Stack>
        </Center>
    );
};

DefaultLayout.propTypes = {
    children: PropTypes.object,
};

export default DefaultLayout;
